import { ResourceDataType, ResourceErrorsType } from '@components/SummarySelection/data/createResource';
import { CategoryType } from '@model/Category';
import { PackageType } from '@model/Package';
import { SkuType } from '@model/Sku';
import { PackageSku } from './packageSku';

export interface SummaryStateType {
    package_id?: number | null;
    package?: PackageType | null;
    products?: PackageType[];
    skus_ids?: number[];
    skus?: SkuType[];
    isDR?: boolean;

    package_skus?: PackageSku[];

    category_id?: number | null;
    category?: CategoryType | null;

    loading?: boolean;
    radio?: boolean;

    rawData?: ResourceDataType;
    data?: ResourceDataType;
    errors?: ResourceErrorsType;
    customer_id?: number | null;

    showPrices?: boolean;
    noBar?: boolean;
    onAdd?: (data: any) => any;

    // Extra configuration
    withSkus?: boolean;
    withProducts?: boolean;

    skuTransformData?: (data: any) => any;
    categoryTransformData?: (data: any) => any;
    packageTransformData?: (data: any) => any;

    skuPrepareConfig?: (config: any) => any;
    categoryPrepareConfig?: (config: any) => any;
    packagePrepareConfig?: (config: any) => any;
}

export const emptySummary = (): SummaryStateType => ({
    package_id: null,
    package: null,
    products: [],
    skus_ids: [],
    skus: [],
    package_skus: [],
    loading: false,
    radio: false,
    isDR: false,
    category_id: null,
    category: null,
    rawData: { skus: null, packages: null, categories: null },
    data: { skus: null, packages: null, categories: null },
    errors: { skus: null, packages: null, categories: null },
    customer_id: null,
    showPrices: true,
    noBar: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onAdd: () => {},

    // Extra configuration
    withSkus: true,
    withProducts: true,

    skuTransformData: (data) => data,
    categoryTransformData: (data) => data,
    packageTransformData: (data) => {
        const filteredPackages = data.items
            .filter(
                (item) =>
                    item.subcategories.length > 0 ||
                    typeof item.price_range.lowest === 'number' ||
                    typeof item.price_range.highest === 'number',
            )
            .map((item) => {
                item.subcategories = item.subcategories.map(
                    ({ default_sku, default_sku_id, subcategory_to_repeat, subcategory }) => ({
                        default_sku,
                        default_sku_id,
                        subcategory_to_repeat,
                        ...subcategory,
                    }),
                );
                return item;
            });
        return { ...data, items: filteredPackages };
    },

    skuPrepareConfig: (config) => config,
    categoryPrepareConfig: (config) => config,
    packagePrepareConfig: (config) => config,
});
